/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentSessionStatus } from '../../models/agent-session-status';
import { GetAgentSessionsResult } from '../../models/get-agent-sessions-result';
import { SessionOrigin } from '../../models/session-origin';

export interface ApiSessionsGet$Params {
  agentId?: string;
  calledById?: string;
  status?: AgentSessionStatus;
  testRunId?: string;
  origin?: SessionOrigin;
  dateFrom?: string;
  dateTo?: string;
  cursor?: string;
  limit?: number;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiSessionsGet(http: HttpClient, rootUrl: string, params?: ApiSessionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAgentSessionsResult>> {
  const rb = new RequestBuilder(rootUrl, apiSessionsGet.PATH, 'get');
  if (params) {
    rb.query('agentId', params.agentId, {});
    rb.query('calledById', params.calledById, {});
    rb.query('status', params.status, {});
    rb.query('testRunId', params.testRunId, {});
    rb.query('origin', params.origin, {});
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
    rb.query('cursor', params.cursor, {});
    rb.query('limit', params.limit, {});
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAgentSessionsResult>;
    })
  );
}

apiSessionsGet.PATH = '/api/Sessions';
